export const isShallowEqual = (
	obj1,
	obj2
) => {
	const keys1 = Object.keys(obj1);
	const keys2 = Object.keys(obj2);

	if (keys1.length !== keys2.length) {
		return false;
	}
	return keys1.every((key1) => Object.is(obj1[key1], obj2[key1]));
};
